// The calculator's suggested amount on a loan: whether there is one to fill
// in, and the loan's deduction day. Pure, so it is tested on its own
// (suggestion.test.js); suggestedTerms.js quotes and saves it.
import { deductionDayFromDates } from '../../utils/dateUtils';

/** The deduction day the loan was made with (the loan does not always store it). */
export const loanDeductionDay = (loan) => loan?.deduction_day ?? deductionDayFromDates(loan?.start_date, loan?.due_date) ?? null;

/**
 * The suggestion to fill in: the calculator's amount (and term) when the loan
 * asks for more. null when there is none, or the loan already has it.
 */
export const pendingSuggestion = (loan, calculator) => {
  const s = calculator?.suggestion;
  if (!s || !(Number(s.amount) > 0)) return null;
  const asked = Number(loan?.principal_amount) || 0;
  const sameAmount = Math.round(asked * 100) === Math.round(Number(s.amount) * 100);
  const sameTerm = Number(loan?.duration_months) === Number(s.months);
  return sameAmount && sameTerm ? null : s;
};
